import { render } from "./Silver.vue?vue&type=template&id=51288df2"
import script from "./Silver.vue?vue&type=script&lang=js"
export * from "./Silver.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/hero/auctions/Silver.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "51288df2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('51288df2', __exports__)) {
    api.reload('51288df2', __exports__)
  }
  
  module.hot.accept("./Silver.vue?vue&type=template&id=51288df2", () => {
    api.rerender('51288df2', render)
  })

}


export default __exports__